import { getIDToken } from "../utils/utils";
import * as config from "../config.js";

export const getUser = async (public_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  console.log("!!! USER ID: ", public_id);
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/user/${public_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    }
  );

  const results = await response.json();
  console.log("!!! RESULTS: ", results);

  if (results.success) {
    return results.user;
  }

  return null;
};

export const sendUserEmail = async (
  public_id,
  email_address,
  subject,
  message
) => {
  const url = `${config.REST_SERVER_URL}/admin/user/send_email/${public_id}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
    body: JSON.stringify({
      email_address: email_address,
      subject: subject,
      message: message,
    }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const sendGroupEmail = async (
  clientId,
  toEmails,
  userGroups,
  subject,
  message,
  fromEmail
) => {
  const url = `${config.REST_SERVER_URL}/admin/user/send_group_email/${clientId}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
    body: JSON.stringify({
      user_groups: userGroups,
      to_emails: toEmails,
      subject: subject,
      message: message,
      from_email: fromEmail,
    }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const sendUserNotification = async (public_id, subject, message) => {
  const url = `${config.REST_SERVER_URL}/admin/user/send_notification/${public_id}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
    body: JSON.stringify({
      subject: subject,
      message: message,
    }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const sendGroupNotification = async (
  clientId,
  userIds,
  subject,
  message
) => {
  const url = `${config.REST_SERVER_URL}/admin/user/send_group_notification/${clientId}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
    body: JSON.stringify({
      user_ids: userIds,
      subject: subject,
      message: message,
    }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const saveUser = async (user) => {
  // We dispatch requestLogin to kickoff the call to the API
  //dispatch(requestLogin(creds));

  const method = user.public_id ? "PUT" : "POST";
  const url = user.public_id
    ? `${config.REST_SERVER_URL}/admin/user/${user.public_id}`
    : `${config.REST_SERVER_URL}/admin/user`;
  const response = await fetch(url, {
    method: method,
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
    body: JSON.stringify(user),
  });

  const results = await response.json();
  console.log("!!! RESULTS: ", results);
  if (results.success) {
    return results.user;
  }
  return false;
};

export const deleteUser = async (public_id) => {
  const url = `${config.REST_SERVER_URL}/admin/user/${public_id}`;
  const response = await fetch(url, {
    method: "DELETE",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const createUsers = async (users) => {
  const url = `${config.REST_SERVER_URL}/admin/user/bulk_create`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
    body: JSON.stringify({ users: users }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};
